import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, signal, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationItem } from '@markant-platform/shared/navigation/model';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MarkantElementsModule } from '@markant/elements-angular';
import { take } from 'rxjs';

@Component({
  standalone: true,
  selector: 'markant-platform-navigation-accordion',
  templateUrl: './navigation-accordion.component.html',
  styleUrls: ['./navigation-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslocoPipe, RouterLink, RouterLinkActive, MarkantElementsModule],
})
export class NavigationAccordionComponent implements OnChanges {
  @Input() drawerItems?: NavigationItem[] | null;

  private readonly router: Router = inject(Router);
  private readonly translocoService: TranslocoService = inject(TranslocoService);

  $labelHasTranslation = signal(false);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['drawerItems']) {
      if (this.drawerItems?.[0]?.label) {
        const { label } = this.drawerItems[0];
        const labelTransloco = `dashboardOverview.navigation.${label}.label`;

        if (label) {
          this.translocoService
            .selectTranslate(labelTransloco)
            .pipe(take(1))
            .subscribe(translation => {
              this.$labelHasTranslation.set(translation !== labelTransloco);
            });
        }
      }
    }
  }

  onDrawerItemClick(item: NavigationItem): void {
    if (item.children.length) {
      item.isCollapsed = !item.isCollapsed;
    } else if (item.route) {
      this.router.navigateByUrl(item.route);
    }
  }
}
